import { skipToken } from '@reduxjs/toolkit/query';

// Moments resolves a legacy (Rails) coach id to the coach's Moments person id
// only through the feature-flag subject read, and authorizes a member's read
// of their coach per flag. This key is a coach-targeted flag that members may
// read for their coach, so the read returns `subject.personId`. Only that
// identity is used: whether the coach is on Mento Calendar comes from
// `coachProfile.schedulingProvider` (see `usesMomentsScheduling`), never from
// the flag's `enabled` value.
export const COACH_IDENTITY_FLAG_KEY = 'DIRECT_PARTICIPANT_APPOINTMENT_BOOKING';

export const coachIdentityQueryArg = (coachExternalId?: string | null) => {
  const externalId = coachExternalId?.trim();
  return externalId
    ? { externalId, flagKey: COACH_IDENTITY_FLAG_KEY }
    : skipToken;
};
